import type { FC } from "react";
import { useState } from "react";
import type { ICategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import ReactDOMServer from "react-dom/server";
import { useOnEnter } from "app/custom-hooks/useOnKeyUp";
import { allTrackers } from "app/services/track/track";
import { resolveCustomAttributes } from "app/pages/industry-analysis/home/resolveCustomAttributes";
import { DeleteAssetConfirm } from "app/components/modals/components/DeleteAssetConfirm";
import SegmentsApiService from "app/services/segments/segmentsApiService";

interface IDeleteIndustryConfirm {
    onClose: VoidFunction;
    industry: ICategory;
    onDelete: VoidFunction;
}

export const DeleteIndustryConfirm: FC<IDeleteIndustryConfirm> = (props) => {
    const { industry, onClose, onDelete: onDeleteCallback } = props;
    const { categoryId, text: industryName, segmentGroupId } = industry ?? {};
    const segmentsApiService = SegmentsApiService.getInstance();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const onDelete = () => {
        setIsLoading(true);
        UserCustomCategoryService.deleteCustomCategory({ id: categoryId }).then(onClose).then(onDeleteCallback);
        if (segmentGroupId) {
            segmentsApiService.refreshSegmentsMetaData(); // if the industry was created from a segment group, we need to refresh the segments metadata
        }
        allTrackers.dispatchTrackEvent(
            "Pop Up",
            "open",
            "Delete custom industry/Confirm deletion",
            resolveCustomAttributes(industry),
        );
    };
    useOnEnter(onDelete);
    const content = (
        <I18n
            dangerouslySetInnerHTML={true}
            dataObj={{ industryName: ReactDOMServer.renderToString(<b>{industryName}</b>) }}
        >
            {"custom.industries.confirm.delete.content"}
        </I18n>
    );
    return (
        <DeleteAssetConfirm
            title={translate("custom.industries.confirm.delete.title")}
            content={content}
            onClose={onClose}
            isLoading={isLoading}
            onDelete={onDelete}
        />
    );
};
